/*==========================================================
HOMEPAGE RESPONSIVE SCRIPTS
==========================================================*/

$(window).load(function () {
    initialiseSocialFeedSlider();
    if ($('.dateList-events .dateList_item').length > 0) { initialiseEventSlider(); }
});

$(function() {
    if ($('#uber').hasClass('homepage')) {
        //News and Events Feed
        if ($().matchHeight) {
            $('.matchHeight').matchHeight();
        }
    }

    $('.eventsFeed .dateList_item').matchHeight();

     //events carousel
     $('.homeBannerCarousel__inner').flickity({
        adaptiveHeight: false,
        autoPlay: 5000,
        cellAlign: 'left',
        contain: true,
        draggable: true,
        pageDots: true,
        prevNextButtons: false,
        pauseAutoPlayOnHover: true,
        setGallerySize: true,
        wrapAround: true,
        on: {
            ready: function() {
                // Add pause button
                var pause = '<button class="flickity-button pause" type="button"><span class="ic-sr-only">Pause Banner</span></button>';
                $(pause).insertAfter('.homeBannerCarousel__inner .flickity-page-dots');

                $('.homeBannerCarousel__inner .flickity-page-dots .dot').each(function(index){
                    $(this).attr('aria-label', 'Banner ' + (index + 1) );
                });
             }
        }
    });

    $('.homeBannerCarousel__inner .flickity-button.pause').on('click', function() {
        if ($(this).hasClass('paused')) {
            $('.homeBannerCarousel__inner .flickity-button.pause span').text('Pause Banner');
            $('.homeBannerCarousel__inner').flickity('playPlayer');
        } else {
            $('.homeBannerCarousel__inner .flickity-button.pause span').text('Play Banner');
            $('.homeBannerCarousel__inner').flickity('stopPlayer');
        }
        $(this).toggleClass('paused');
    });

    if (!window.matchMedia('(min-width: 1200px').matches) {
        $('.homeBannerCarousel__inner').flickity('stopPlayer');
    }

    //story features carousel
    $('.storyFeature__inner').flickity({
        adaptiveHeight: false,
        autoPlay: 5000,
        cellAlign: 'left',
        contain: true,
        draggable: true,
        pageDots: true,
        prevNextButtons: false,
        pauseAutoPlayOnHover: true,
        setGallerySize: true,
        wrapAround: true,
        on: {
            ready: function() {
                $('.storyFeature__inner .flickity-page-dots').wrap('<div class="flickity-controls"/>');
                var pause = '<button class="flickity-button pause" type="button"><span class="ic-sr-only">Pause Story Feature Slider</span></button>';
                $(pause).insertAfter('.storyFeature__inner .flickity-page-dots');

                $('.storyFeature__inner .flickity-page-dots .dot').each(function(index){
                    $(this).attr('aria-label', 'Story Slide ' + (index + 1) );
                });
            }
        }
    });

    $('.storyFeature__inner .flickity-button.pause').on('click', function() {
        if ($(this).hasClass('paused')) {
            $('.storyFeature__inner .flickity-button.pause span').text('Pause Story Feature Slider');
            $('.storyFeature__inner').flickity('playPlayer');
        } else {
            $('.storyFeature__inner .flickity-button.pause span').text('Play Story Feature Slider');
            $('.storyFeature__inner').flickity('stopPlayer');
        }
        $(this).toggleClass('paused');
    });

    // Social previous
    $('.socialMedia .flickity-button.previous').on( 'click', function() {
        $('.SMDropdownInner').flickity('previous');
    });
     // Social next
    $('.socialMedia .flickity-button.next').on( 'click', function() {
     $('.SMDropdownInner').flickity('next');
    });

    //video carousel
    $('.videoSlider__inner').flickity({
        cellSelector: '.videoSlider__item',
        cellAlign: 'left',
        contain: true,
        prevNextButtons: true,
        pageDots: true,
        on: {
            ready: function() {
                $('.videoSlider__inner .flickity-page-dots .dot').each(function(index){
                    $(this).attr('aria-label', 'Video Slide ' + (index + 1) );
                });
            }
        }
    });
});

function initialiseEventSlider() {
    //events carousel
    $('.dateList-events').flickity({
        cellAlign: 'left',
        cellSelector: '.dateList_item',
        groupCells: true,
        contain: true,
        imagesLoaded: true,
        pageDots: false,
        on: {
            ready: function () {
                if ($().matchHeight) {
                    $('.matchHeight').matchHeight();
                }
            }
        }
    });
}

function initialiseSocialFeedSlider() {
    //social carousel
    $('.SMDropdownInner').flickity({
        cellAlign: 'left',
        cellSelector: '.socialMedia__feed__item',
        groupCells: true,
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        imagesLoaded: true,
        on: {
            ready: function () {
                $('.SMDropdownInner .flickity-viewport').css('height', 'auto');
            }
        }
    });
}

$(function() {
    if ($('.dateList-events').length ) {
        initialiseEventSlider();
    }

    initialiseSocialFeedSlider();
});
